import { MultiLanguageField } from '../model';

export type OlympiadSelectItem = {
  name?: MultiLanguageField | null;
  studyYearName?: MultiLanguageField | null;
  schoolGradeName?: MultiLanguageField | null;
  schoolGradeNames?: MultiLanguageField[] | null;
  subjectName?: MultiLanguageField | null;
  subjectNames?: MultiLanguageField[] | null;
};

export function normalizeMultilangNames(
  names?: MultiLanguageField | MultiLanguageField[] | null,
): MultiLanguageField[] {
  if (!names) {
    return [];
  }
  return Array.isArray(names) ? names.filter(Boolean) : [names];
}

export function resolveMultilangLabel(
  value: MultiLanguageField | string | null | undefined,
  lang: string,
): string {
  if (!value) {
    return '';
  }
  if (typeof value === 'string') {
    return value;
  }
  return (
    value[lang as keyof MultiLanguageField] ||
    value.uz ||
    value.ru ||
    value.en ||
    value.kaa ||
    ''
  );
}

export function joinMultilangNames(
  names: MultiLanguageField | MultiLanguageField[] | null | undefined,
  lang: string,
  separator = ', ',
): string {
  return normalizeMultilangNames(names)
    .map((item) => resolveMultilangLabel(item, lang))
    .filter(Boolean)
    .join(separator);
}

/** Olimpiada select: fan / nom / o'quv yili / sinf */
export function formatOlympiadSelectLabel(
  item: OlympiadSelectItem | null | undefined,
  lang: string,
): string {
  if (!item) {
    return '';
  }

  const parts = [
    joinMultilangNames(item.subjectNames ?? item.subjectName, lang),
    resolveMultilangLabel(item.name, lang),
    resolveMultilangLabel(item.studyYearName, lang),
    joinMultilangNames(item.schoolGradeNames ?? item.schoolGradeName, lang),
  ].filter(Boolean);

  return parts.join(' / ');
}

export type StageSelectItem = {
  name?: MultiLanguageField | string | null;
  olympiadName?: MultiLanguageField | string | null;
  subjectName?: MultiLanguageField | string | null;
  subjectNames?: MultiLanguageField[] | null;
  schoolGradeName?: MultiLanguageField | string | null;
  schoolGradeNames?: MultiLanguageField[] | null;
};

/** Bosqich select: fan / bosqich nomi / sinf */
export function formatStageSelectLabel(
  item: StageSelectItem | null | undefined,
  lang: string,
): string {
  if (!item) {
    return '';
  }

  const subject =
    item.subjectNames?.length
      ? joinMultilangNames(item.subjectNames, lang)
      : resolveMultilangLabel(item.subjectName, lang);

  const grade =
    item.schoolGradeNames?.length
      ? joinMultilangNames(item.schoolGradeNames, lang)
      : resolveMultilangLabel(item.schoolGradeName, lang);

  const parts = [
    subject,
    resolveMultilangLabel(item.name, lang),
    grade,
  ].filter(Boolean);

  return parts.join(' / ');
}
